<template>
  <div class="shoppe">
    <el-button @click="$router.back()">返回</el-button>
    <p class="mt20 f14">
      <span class="label">名单编号：</span>{{ nameCode
      }}<span class="label ml20">名单描述</span>：{{ desc }}
    </p>
    <div class="query-form mt20">
      <el-form label-position="right" label-width="90px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <!-- <el-select v-model="queryForm.vendorAliasId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.value" :key="item.value"></el-option>
                  </el-select> -->
                  <BrandSelect
                    v-model="queryForm.vendorAliasId"
                    :data="vendorList"
                    :label="vendorNameAlias"
                    filterable
                    clearable
                  ></BrandSelect>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店名称">
                  <!-- <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select> -->
                  <BrandSelect
                    v-model="queryForm.vendorId"
                    :data="vendorList"
                    filterable
                    clearable
                  ></BrandSelect>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="Vendor ID">
                  <el-input
                    type="number"
                    v-model.number="queryForm.inputVendorId"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-button type="primary" @click="showForm">新增配置</el-button>
    <el-button type="primary" @click="showBatchForm">批量新增买手店</el-button>

    <el-table :data="tableData" v-loading="tableLoading">
      <el-table-column prop="vendorId" label="店铺ID"></el-table-column>
      <el-table-column prop="vendorName" label="店铺名称">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column prop="fieldValue" label="附加信息"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">修改</el-link>
          <el-link type="primary" class="ml10" @click="removeItem(scope.row)"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog
      append-to-body
      title="新增"
      :visible.sync="dialogVisible"
      width="770px"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <template v-for="(config, index) in form.configList">
          <el-form-item
            :key="'formitem1' + index"
            label="买手店"
            :prop="`configList.${index}.vendorId`"
            :rules="[{ required: true, message: '请选择买手店' }]"
          >
            <!-- <el-select v-model="config.vendorId" filterable style="width: 300px;">
              <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select> -->
            <BrandSelect
              v-model="config.vendorId"
              :data="vendorList"
              filterable
              clearable
              :style="{ width: '500px' }"
            ></BrandSelect>
            <el-button class="ml10" v-if="index === 0" @click="onClickAdd"
              >添加</el-button
            >
            <el-button
              class="ml10"
              v-if="index !== 0"
              @click="onClickRemove(index)"
              type="danger"
              plain
              >删除</el-button
            >
          </el-form-item>
          <el-form-item
            :key="'formitem2' + index"
            :prop="`configList.${index}.fieldValue`"
            label="附加信息"
          >
            <el-input
              type="textarea"
              :rows="6"
              v-model="config.fieldValue"
              style="width: 500px"
            ></el-input>
          </el-form-item>
        </template>
        <template v-if="blackWhiteList.length">
          <el-form-item
            v-for="(item, idx) in blackWhiteList"
            :key="idx"
            :label="item.name"
            :rules="[{ required: item.required }]"
          >
            <el-input
              v-if="item.type == 'input'"
              type="text"
              v-model="item.value"
              style="width: 500px"
            ></el-input>
            <el-select
              v-if="item.type == 'option'"
              v-model="item.value"
              clearable
              filterable
              :multiple="item.multiple"
              style="width: 500px"
            >
              <el-option
                v-for="(item, idx) in item.options"
                :key="idx"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-time-select
              v-if="item.type == 'timeOption'"
              v-model="item.value"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00',
              }"
              placeholder="选择时间"
              style="width: 500px"
            >
            </el-time-select>
            <div v-if="item.type == 'group'">
              <el-button
                type="primary"
                size="small"
                @click="addGroup(idx)"
                style="margin-bottom: 10px"
                >添加{{ item.name }}</el-button
              >
              <el-form v-if="item.value && item.value.length" label-width="100px" label-position="left">
                <el-card
                  v-for="(groups, index) in item.value"
                  :key="index"
                  style="width: 500px; position: relative; margin-bottom: 10px"
                >
                  <h3>{{ item.name }}{{ index + 1 }}</h3>
                  <div
                    style="
                      position: absolute;
                      top: 6px;
                      right: 10px;
                      cursor: pointer;
                    "
                    @click="removeGroup(idx, index)"
                  >
                    <i
                      class="el-icon-circle-close"
                      style="font-size: 24px; color: red"
                    ></i>
                  </div>
                  <el-form-item
                    :label="group.name"
                    v-for="group in groups"
                    :key="group"
                  >
                    <el-input
                      v-if="group.type == 'input'"
                      type="text"
                      v-model="group.value"
                      size="small"
                      style="width: 340px"
                      clearable
                    ></el-input>
                    <el-select
                      v-if="group.type == 'option'"
                      v-model="group.value"
                      clearable
                      filterable
                      :multiple="group.multiple"
                      size="small"
                      style="width: 340px"
                    >
                      <el-option
                        v-for="(group, idx) in group.options"
                        :key="idx"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                    <el-time-select
                      v-if="item.type == 'timeOption'"
                      v-model="group.value"
                      :picker-options="{
                        start: '00:00',
                        step: '01:00',
                        end: '23:00',
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 340px"
                    >
                    </el-time-select>
                  </el-form-item>
                </el-card>
              </el-form>
            </div>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      title="修改"
      :visible.sync="dialogVisible2"
      width="700px"
    >
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item
          label="买手店"
          prop="vendorId"
          :rules="[{ required: true, message: '请选择买手店' }]"
        >
          <!-- <el-select v-model="editForm.vendorId" filterable>
            <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select> -->
          <BrandSelect
            v-model="editForm.vendorId"
            :data="vendorList"
            filterable
            clearable
            :style="{ width: '500px' }"
          ></BrandSelect>
        </el-form-item>
        <template v-if="blackWhiteList.length">
          <el-form-item
            v-for="(item, idx) in blackWhiteList"
            :key="idx"
            :label="item.name"
            :rules="[{ required: item.required }]"
          >
            <el-input
              v-if="item.type == 'input'"
              type="text"
              v-model="item.value"
              style="width: 500px"
            ></el-input>
            <el-select
              v-if="item.type == 'option'"
              v-model="item.value"
              clearable
              filterable
              :multiple="item.multiple"
              style="width: 500px"
            >
              <el-option
                v-for="(item, idx) in item.options"
                :key="idx"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-time-select
              v-if="item.type == 'timeOption'"
              v-model="item.value"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00',
              }"
              placeholder="选择时间"
              style="width: 500px"
            >
            </el-time-select>
            <div v-if="item.type == 'group'">
              <el-button
                type="primary"
                size="small"
                @click="addGroup(idx)"
                style="margin-bottom: 10px"
                >添加{{ item.name }}</el-button
              >
              <el-form v-if="item.value && item.value.length" label-width="100px" label-position="left">
                <el-card
                  v-for="(groups, index) in item.value"
                  :key="index"
                  style="width: 500px; position: relative; margin-bottom: 10px"
                >
                  <h3>{{ item.name }}{{ index + 1 }}</h3>
                  <div
                    style="
                      position: absolute;
                      top: 6px;
                      right: 10px;
                      cursor: pointer;
                    "
                    @click="removeGroup(idx, index)"
                  >
                    <i
                      class="el-icon-circle-close"
                      style="font-size: 24px; color: red"
                    ></i>
                  </div>
                  <el-form-item
                    :label="group.name"
                    v-for="group in groups"
                    :key="group"
                  >
                    <el-input
                      v-if="group.type == 'input'"
                      type="text"
                      v-model="group.value"
                      size="small"
                      style="width: 340px"
                      clearable
                    ></el-input>
                    <el-select
                      v-if="group.type == 'option'"
                      v-model="group.value"
                      clearable
                      filterable
                      :multiple="item.multiple"
                      size="small"
                      style="width: 340px"
                    >
                      <el-option
                        v-for="(group, idx) in group.options"
                        :key="idx"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                    <el-time-select
                      v-if="item.type == 'timeOption'"
                      v-model="group.value"
                      :picker-options="{
                        start: '00:00',
                        step: '01:00',
                        end: '24:00',
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 340px"
                    >
                    </el-time-select>
                  </el-form-item>
                </el-card>
              </el-form>
            </div>
          </el-form-item>
        </template>
        <el-form-item prop="fieldValue" label="附加信息">
          <el-input
            type="textarea"
            :rows="6"
            v-model="editForm.fieldValue"
            style="width:500px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="批量新增买手店"
      :visible.sync="dialogVisible3"
      :close-on-click-modal="false"
      width="700px"
    >
      <p>请输入Vendor ID(一行一个，最多10000个)</p>
      <el-input
        type="textarea"
        :rows="6"
        placeholder="请输入内容"
        v-model="batchVendorId"
      ></el-input>
      <template v-if="blackWhiteList.length">
        <el-form label-width="120px" style="padding-top: 20px">
          <el-form-item
            v-for="(item, idx) in blackWhiteList"
            :key="idx"
            :label="item.name"
            :rules="[{ required: item.required }]"
          >
            <el-input
              v-if="item.type == 'input'"
              type="text"
              v-model="item.value"
              style="width: 500px"
            ></el-input>
            <el-select
              v-if="item.type == 'option'"
              v-model="item.value"
              clearable
              filterable
              :multiple="item.multiple"
              style="width: 500px"
            >
              <el-option
                v-for="(item, idx) in item.options"
                :key="idx"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-time-select
              v-if="item.type == 'timeOption'"
              v-model="item.value"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00',
              }"
              placeholder="选择时间"
              style="width: 500px"
            >
            </el-time-select>
            <div v-if="item.type == 'group'">
              <el-button
                type="primary"
                size="small"
                @click="addGroup(idx)"
                style="margin-bottom: 10px"
                >添加{{ item.name }}</el-button
              >
              <el-form v-if="item.value && item.value.length" label-width="100px" label-position="left">
                <el-card
                  v-for="(groups, index) in item.value"
                  :key="index"
                  style="width: 500px; position: relative; margin-bottom: 10px"
                >
                  <h3>{{ item.name }}{{ index + 1 }}</h3>
                  <div
                    style="
                      position: absolute;
                      top: 6px;
                      right: 10px;
                      cursor: pointer;
                    "
                    @click="removeGroup(idx, index)"
                  >
                    <i
                      class="el-icon-circle-close"
                      style="font-size: 24px; color: red"
                    ></i>
                  </div>
                  <el-form-item
                    :label="group.name"
                    v-for="group in groups"
                    :key="group"
                  >
                    <el-input
                      v-if="group.type == 'input'"
                      type="text"
                      v-model="group.value"
                      size="small"
                      style="width: 340px"
                      clearable
                    ></el-input>
                    <el-select
                      v-if="group.type == 'option'"
                      v-model="group.value"
                      clearable
                      filterable
                      :multiple="item.multiple"
                      size="small"
                      style="width: 340px"
                    >
                      <el-option
                        v-for="(group, idx) in group.options"
                        :key="idx"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                    <el-time-select
                      v-if="item.type == 'timeOption'"
                      v-model="group.value"
                      :picker-options="{
                        start: '00:00',
                        step: '01:00',
                        end: '23:00',
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 340px"
                    >
                    </el-time-select>
                  </el-form-item>
                </el-card>
              </el-form>
            </div>
          </el-form-item>
        </el-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBlackWhiteNameConfig,
  addBlackWhiteNameConfig,
  updateBlackWhiteNameConfig,
  deleteBlackWhiteNameConfig,
  queryBlackWhiteName,
} from "../../../api/trace";
import { getVendorListRF } from "../../buyershop/api";
import BrandSelect from "@/views/components/brandSelect";

export default {
  data() {
    return {
      nameCode: this.$route.query.nameCode,
      desc: this.$route.query.desc,
      vendorList: [],
      queryForm: {
        vendorAliasId: null,
        vendorId: null,
        inputVendorId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      form: {
        nameCode: this.$route.query.nameCode,
        configList: [],
      },
      dialogVisible: false,
      dialogVisible2: false,
      editForm: {
        vendorBlackWhiteNameConfigId: null,
        vendorId: null,
        fieldValue: null,
        nameCode: null,
      },
      dialogVisible3: false,
      batchVendorId: null,
      blackWhiteId: null,
      initBlackWhiteList: [],
      blackWhiteList: [],
      //   [
      //   {
      //     name: "结算周期",
      //     type: "option", // option 下拉选择，input： 输入框
      //     defaultValue: "1",
      //     options: [
      //       {
      //         key: "1",
      //         value: "正常半月结",
      //       },
      //       {
      //         key: "2",
      //         value: "半月结T+3(只计算工作日)",
      //       },
      //     ],
      //   },
      //   {
      //     name: "是否发送邮件",
      //     type: "input", // option 下拉选择，input： 输入框
      //     defaultValue: 1,
      //     options: [
      //       {
      //         key: "1",
      //         value: "是",
      //       },
      //       {
      //         key: "2",
      //         value: "否",
      //       },
      //     ],
      //   },
      //   {
      //     name: "日期",
      //     type: "timeOption", // option 下拉选择，input： 输入框
      //     defaultValue: null,
      //     options: [
      //       {
      //         key: "1",
      //         value: "是",
      //       },
      //       {
      //         key: "2",
      //         value: "否",
      //       },
      //     ],
      //   },
      //   {
      //     name: "group",
      //     type: "group", // option 下拉选择，input： 输入框
      //     defaultValue: null,
      //     options: [
      //       {
      //         key: "1",
      //         value: "是",
      //       },
      //       {
      //         key: "2",
      //         value: "否",
      //       },
      //     ],
      //   },
      // ],
    };
  },
  components: { BrandSelect },
  mounted() {
    getVendorListRF(true).then((res) => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data.map((item) => ({
          value: item.vendorId,
          label: item.vendorName,
          vendorNameAlias: item.vendorNameAlias,
        }));
      }
    });
    this.queryBlackWhiteName();
    this.getTableData();
  },
  methods: {
    queryBlackWhiteName() {
      queryBlackWhiteName({ nameCode: this.nameCode }).then((res) => {
        console.log(res.data.data.paramDefinitions);
        if (res.data && res.data.data && res.data.data.paramDefinitions) {
          var blackWhiteList = res.data.data.paramDefinitions.map((item) => {
            return {
              ...item,
              value: item.defaultValue,
            };
          });
          this.initBlackWhiteList = [...blackWhiteList];
          this.BlackWhiteList = [...blackWhiteList];
        }
      });
    },
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.inputVendorId = null;
      this.queryForm.vendorAliasId = null;
      this.queryForm.vendorId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      getBlackWhiteNameConfig({
        ...this.queryForm,
        vendorId:
          this.queryForm.inputVendorId ||
          this.queryForm.vendorAliasId ||
          this.queryForm.vendorId,
        nameCode: this.nameCode,
      }).then((res) => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
        this.tableLoading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    showForm() {
      this.form.configList = [
        {
          vendorId: null,
          fieldValue: null,
        },
      ];
      var blackWhiteList = this.initBlackWhiteList.map((item) => {
        var newItem = {
          ...item,
          value: item.defaultValue,
        };
        if (newItem.type == "group") {
          newItem.value = [newItem.children];
        }
        return { ...newItem };
      });
      this.blackWhiteList = JSON.parse(JSON.stringify(blackWhiteList));
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onClickAdd() {
      this.form.configList.unshift({
        vendorId: null,
        fieldValue: null,
      });
    },
    onClickRemove(index) {
      this.form.configList.splice(index, 1);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            var params = {
              ...this.form,
            };
            var errorFlag = false;
            if (this.blackWhiteList.length) {
              params.paramValues = this.blackWhiteList.map((item) => {
                var paramValue = {
                  name: item.name,
                  value: item.value,
                };
                if (item.required && !item.value && item.type != "group") {
                  errorFlag = true;
                }
                if (item.type == "group") {
                  var valueList = item.value.map((it) => {
                    var isNotEmpty = false;
                    var newIt = it.map((i) => {
                      if (i.value) {
                        isNotEmpty = true;
                      }
                      return {
                        name: i.name,
                        value: i.value || null,
                      };
                    });
                    if (item.required && !isNotEmpty || !item.required && !isNotEmpty && it.length) {
                      errorFlag = true;
                    }
                    return newIt;
                  });
                  paramValue.value = JSON.stringify(valueList);
                }
                if(paramValue.value && typeof paramValue.value === 'object'){
                  paramValue.value = JSON.stringify(paramValue.value);
                }
                return paramValue;
              });
            }
            if (errorFlag) {
              this.$message.error("请完善信息");
              return;
            }
            this.repeatSave = true;
            addBlackWhiteNameConfig(params)
              .then((res) => {
                this.repeatSave = false;
                if (res.data.success) {
                  if (res.data.message === "") {
                    this.$message.success("新增成功");
                  } else {
                    this.$message.warning(res.data.message);
                  }
                  this.dialogVisible = false;
                  this.getTableData();
                } else {
                  this.$message.error(res.data.data || res.data.message);
                }
              })
              .catch((err) => {
                this.repeatSave = false;
              });
          }
        } else {
          this.$message.error("请完善信息");
          return false;
        }
      });
    },
    editItem(row) {
      this.editForm = { ...row, vendorId: null };
      var blackWhiteList = this.initBlackWhiteList.map((item) => {
        var newItem = (row.paramValues || []).find(
          (it) => it.name == item.name
        ) || {
          value: "",
        };
        var value = newItem.value;
        if (item.type === "group") {
          if (newItem.value) var groupPList = JSON.parse(newItem.value);
          value = groupPList.map((groupList) => {
            var newGroupPList = groupList.map((group) => {
              var newGroup = (item.children || []).find(
                (it) => it.name == group.name
              );
              if(group.value && newGroup.type == "option" && newGroup.multiple){
                group.value = JSON.parse(group.value)
              }
              return {
                ...newGroup,
                value: group.value,
              };
            });
            return newGroupPList;
          });
        }

        if(value && item.type == "option" && item.multiple){
          value = JSON.parse(value)
        }
        return {
          ...item,
          value,
        };
      });
      this.blackWhiteList = JSON.parse(JSON.stringify(blackWhiteList));
      console.log("blackWhiteList", this.blackWhiteList);
      this.dialogVisible2 = true;
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate();
        setTimeout(() => {
          this.editForm.vendorId = row.vendorId;
        }, 500);
      });
    },
    submitEditForm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            var params = {
              ...this.editForm,
            };
            var errorFlag = false;
            if (this.blackWhiteList.length) {
              params.paramValues = this.blackWhiteList.map((item) => {
                var paramValue = {
                  name: item.name,
                  value: item.value,
                };
                if (item.required && !item.value && item.type != "group") {
                  errorFlag = true;
                }
                if (item.type == "group") {
                  var valueList = item.value.map((it) => {
                    var isNotEmpty = false;
                    var newIt = it.map((i) => {
                      if (i.value) {
                        isNotEmpty = true;
                      }
                      return {
                        name: i.name,
                        value: i.value || null,
                      };
                    });
                    if (item.required && !isNotEmpty || !item.required && !isNotEmpty && it.length) {
                      errorFlag = true;
                    }
                    return newIt;
                  });
                  paramValue.value = JSON.stringify(valueList);
                }
                if(paramValue.value && typeof paramValue.value === 'object'){
                  paramValue.value = JSON.stringify(paramValue.value);
                }
                return paramValue;
              });
            }
            if (errorFlag) {
              this.$message.error("请完善信息");
              return;
            }
            this.repeatSave = true;
            updateBlackWhiteNameConfig(params)
              .then((res) => {
                this.repeatSave = false;
                if (res.data.success) {
                  if (res.data.message === "") {
                    this.$message.success("修改成功");
                  } else {
                    this.$message.warning(res.data.message);
                  }
                  this.dialogVisible2 = false;
                  this.getTableData();
                } else {
                  this.$message.error(res.data.data || res.data.message);
                }
              })
              .catch((err) => {
                this.repeatSave = false;
              });
          }
        } else {
          this.$message.error("请完善信息");
          return false;
        }
      });
    },
    removeItem(row) {
      this.$confirm(`确认删除${row.vendorName}吗?`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteBlackWhiteNameConfig({
            vendorBlackWhiteNameConfigId: row.vendorBlackWhiteNameConfigId,
          }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.getTableData();
          });
        })
        .catch(() => {});
    },
    showBatchForm() {
      this.batchVendorId = null;
      var blackWhiteList = this.initBlackWhiteList.map((item) => {
        var newItem = {
          ...item,
          value: item.defaultValue,
        };
        if (newItem.type == "group") {
          newItem.value = [newItem.children];
        }
        return { ...newItem };
      });
      this.blackWhiteList = JSON.parse(JSON.stringify(blackWhiteList));
      this.dialogVisible3 = true;
    },
    submitBatch() {
      let vendorIds = this.batchVendorId
        .split("\n")
        .filter((item) => item != "");
      if (!this.batchVendorId || (vendorIds && vendorIds.length == 0)) {
        this.$message("请输入买手店ID");
        return false;
      }
      if (vendorIds.some((item) => !/(^[1-9]\d*$)/.test(item))) {
        this.$message("Vendor ID 只能输入正整数");
        return false;
      }
      if (vendorIds.length > 10000) {
        this.$message("输入行不允许超过一万");
        return false;
      }
      if (this.repeatSave) {
        return;
      }
      var params = {
        nameCode: this.$route.query.nameCode,
        configList: vendorIds.map((item) => ({ vendorId: item })),
      };
      var errorFlag = false;
      if (this.blackWhiteList.length) {
        params.paramValues = this.blackWhiteList.map((item) => {
          var paramValue = {
            name: item.name,
            value: item.value,
          };
          if (item.required && !item.value && item.type != "group") {
            errorFlag = true;
          }
          if (item.type == "group") {
            var valueList = item.value.map((it) => {
              var isNotEmpty = false;
              var newIt = it.map((i) => {
                if (i.value) {
                  isNotEmpty = true;
                }
                return {
                  name: i.name,
                  value: i.value || null,
                };
              });
              if (item.required && !isNotEmpty || !item.required && !isNotEmpty && it.length) {
                errorFlag = true;
              }
              return newIt;
            });
            paramValue.value = JSON.stringify(valueList);
          }
          if(paramValue.value && typeof paramValue.value === 'object'){
            paramValue.value = JSON.stringify(paramValue.value);
          }
          return paramValue;
        });
      }
      if (errorFlag) {
        this.$message.error("请完善信息");
        return;
      }
      this.repeatSave = true;
      addBlackWhiteNameConfig(params)
        .then((res) => {
          this.repeatSave = false;
          if (res.data.success) {
            if (res.data.message === "") {
              this.$message.success("新增成功");
            } else {
              this.$message.warning(res.data.message);
            }
            this.dialogVisible3 = false;
            this.getTableData();
          } else {
            this.$message.error(res.data.data || res.data.message);
          }
        })
        .catch((err) => {
          this.repeatSave = false;
        });
    },
    addGroup(index) {
      this.blackWhiteList[index].value.push(
        this.blackWhiteList[index].children
      );
    },
    removeGroup(i, j) {
      var cur = this.blackWhiteList[i];
      if (cur.required && cur.value.length === 1) {
        return;
      }
      cur.value.splice(j, 1);
      this.blackWhiteList.splice(i, 1, JSON.parse(JSON.stringify(cur)));
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.mr10 {
  margin-right: 10px;
}
.red {
  color: red;
}
.f14 {
  font-size: 14px;
}
.label {
  color: #999;
}
</style>
